module.exports = __webpack_public_path__ + "static/media/charles4x.9bdcb3cc.png";